import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarNavigation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 33",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M10.333 6.833V4.167m11.334 2.666V4.167m-11.334 8h11.334M9 27.5h14a4 4 0 0 0 4-4V10.833a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4V23.5a4 4 0 0 0 4 4Z"
	})
});
export default SvgCalendarNavigation;
